export default {
  nav: {
    dashboard: '控制台',
    campaigns: '营销活动',
    landingPages: '落地页',
    offers: 'Offer',
    conversions: '转化记录',
    reports: '报告中心',
    alerts: '告警通知',
    billing: '计费订阅',
    trafficSources: '流量源',
    clicks: '追踪日志',
    testing: '追踪测试',
    postbackLogs: 'Postback 日志',
    adminBilling: '定制套餐管理',
    adminPanel: '管理后台',
    backToApp: '返回前台',
  },
  common: {
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    create: '创建',
    confirm: '确认',
    loading: '加载中...',
    noData: '暂无数据',
    search: '搜索',
    refresh: '刷新',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    submit: '提交',
    close: '关闭',
    enable: '启用',
    disable: '禁用',
    status: '状态',
    name: '名称',
    actions: '操作',
    all: '全部',
    yes: '是',
    no: '否',
    logout: '退出',
    prevPage: '上一页',
    nextPage: '下一页',
    saving: '保存中...',
    unknown: '未知',
  },
  campaign: {
    title: 'Campaign 管理',
    create: '创建 Campaign',
    name: 'Campaign 名称',
    status: {
      active: '运行中',
      paused: '已暂停',
      archived: '已归档',
      deleted: '已删除',
    },
    costModel: {
      label: '成本模型',
      cpc: 'CPC (按点击计费)',
      cpm: 'CPM (按千次展示计费)',
      cpa: 'CPA (按转化计费)',
      none: '无',
    },
    trafficSource: '流量源',
    offer: 'Offer',
    clicks: '点击数',
    conversions: '转化数',
    revenue: '收入',
    cost: '成本',
    profit: '利润',
    cvr: 'CVR',
    epc: 'EPC',
    roi: 'ROI',
    action: {
      pause: '暂停',
      start: '启动',
      clone: '克隆',
      archive: '归档',
    },
    wizard: {
      step1: '基本信息', step2: '目标设置', step3: '成本设置', step4: '高级选项', step5: '确认创建',
      trafficSource: '流量来源',
      fallbackUrl: '备用 URL (可选)',
      costModel: '成本模型', costValue: '成本值', currency: '货币',
      tags: '标签', tagsHint: '使用逗号分隔多个标签', tagsPlaceholder: '标签1, 标签2, 标签3',
      notes: '备注', notesPlaceholder: '添加备注信息...',
      selectOffer: '请选择 Offer...',
      noOffers: '暂无可用 Offer，请先在 {link} 中创建',
      confirmMsg: '请检查以下设置，确认无误后创建 Campaign',
      nameLabel: 'Campaign 名称', namePlaceholder: '输入 Campaign 名称',
      saveDraft: '保存草稿', createBtn: '创建 Campaign',
      errName: '请输入 Campaign 名称', errTrafficSource: '请选择流量来源',
      errOffer: '请选择 Offer', errUrl: '请输入有效的 URL', errCostValue: '请输入有效的成本值',
      step1Desc: '设置 Campaign 名称并选择流量来源',
      step2Desc: '选择此 Campaign 关联的 Offer',
      step3Desc: '设置 Campaign 的成本模型和价值',
      step4Desc: '添加标签和备注以便管理',
      step5Desc: '预览配置',
      currencyUSD: '美元 (USD)', currencyCNY: '人民币 (CNY)', currencyEUR: '欧元 (EUR)', currencyGBP: '英镑 (GBP)',
      subtitle: '按步骤配置您的广告追踪活动',
      trafficSourceParams: '流量源参数配置',
      trafficSourceParamsHint: '配置 {name} 的追踪参数，这些参数将被添加到追踪链接中',
      trafficSourceParamsLabel: '流量源参数',
      fallbackHint: '当目标URL无法访问时跳转到此页面',
      trackingDomain: '自定义追踪域名',
      trackingDomainHint: '留空则使用默认追踪域名',
      noTags: '暂无可用标签',
      newTagPlaceholder: '创建新标签',
      folderPlaceholder: '例如：2024年活动',
      notSelected: '未选择',
      createTagFailed: '创建标签失败',
      createFailed: '创建失败，请重试',
      confirmTitle: '确认配置',
      confirmHint: '创建后系统将自动生成追踪链接和 Postback URL，您可以在详情页查看和复制。',
      errNameMin: '名称至少需要 2 个字符',
      errNameMax: '名称最多 100 个字符',
      errCostRequired: '请输入成本数值',
      errCostNegative: '成本数值不能为负数',
      editTitle: '编辑 Campaign',
      editSubtitle: '修改 Campaign 配置',
      destinationUrl: '目标 URL',
      saveFailed: '保存失败，请重试',
      selectTrafficSource: '选择流量源',
    },
    detail: {
      trackingLink: '追踪链接', postbackHint: '将此 URL 配置到您的流量源以接收转化数据',
      todayData: '今日数据', clicks: '点击', conversions: '转化', revenue: '收入', cost: '成本',
      trend: '数据趋势', revenueCost: '收入与成本',
      conversionList: '转化记录', total: '共 {n} 条', addManual: '+ 手动添加',
      noConversions: '暂无转化记录',
      config: '配置信息', trafficSource: '流量源', costModel: '成本模型',
      trackingDomain: '追踪域名', defaultDomain: '默认域名', folder: '文件夹', tags: '标签',
      noTrafficSource: '未设置流量源', createdAt: '创建于', statusControl: '状态控制',
      copied: '已复制', copy: '复制',
      quickActions: '快速操作', editConfig: '编辑配置', editConfigDesc: '修改 Campaign 设置',
      viewReports: '查看报表', viewReportsDesc: '详细数据分析',
      qrCode: '生成二维码', qrCodeDesc: '追踪链接二维码',
      roiAnalysis: 'ROI 分析', returnRate: '投资回报率',
      notFound: 'Campaign 不存在或已被删除', backToList: '返回列表',
      addConversionTitle: '手动添加转化', adding: '添加中...', confirmAdd: '确认添加',
      convStatus: '状态', approve: '通过', reject: '拒绝', none: '无',
    },
    archiveConfirmTitle: '确认归档',
    archiveConfirmMsg: '确定要归档这个 Campaign 吗？',
    archiveConfirmBtn: '归档',
  },
  conversion: {
    title: '转化记录',
    status: {
      pending: '待审核',
      approved: '已通过',
      rejected: '已拒绝',
    },
    payout: 'Payout',
    goal: '目标',
    addManual: '手动添加转化',
    totalCount: '共 {n} 条',
    allCampaigns: '全部 Campaign',
    noData: '暂无转化记录',
    approve: '通过',
    reject: '拒绝',
    pagination: '第 {from}-{to} 条，共 {total} 条',
  },
  report: {
    title: '实时报表',
    today: '今日',
    days7: '7天',
    days30: '30天',
    totalClicks: '总点击',
    uniqueClicks: '独立点击',
    totalConversions: '转化数',
    totalRevenue: '总收入',
    totalProfit: '总利润',
    avgCvr: '平均CVR',
    avgEpc: '平均EPC',
    custom: '自定义',
    trendChart: '点击与转化趋势',
    revenueCost: '收入与成本',
    campaignDetail: 'Campaign 明细',
    trafficDetail: '流量源明细',
    languageDetail: '语言分布',
    carrierDetail: '运营商分布',
    connectionDetail: '连接类型',
  },
  alert: {
    title: '告警与通知',
    rules: '告警规则',
    notifications: '通知记录',
    createRule: '新建规则',
    checkNow: '立即检查',
    checking: '检查中...',
    noRules: '暂无告警规则',
    noNotifications: '暂无通知',
    markAllRead: '全部标为已读',
    metric: {
      clicks: '点击数',
      conversions: '转化数',
      cvr: 'CVR (%)',
      revenue: '收入 ($)',
      profit: '利润 ($)',
      epc: 'EPC ($)',
    },
    condition: { lt: '低于', gt: '高于' },
    threshold: '阈值',
    windowHours: '时间窗口 (小时)',
    allCampaigns: '全部 Campaign',
    editRule: '编辑规则',
    newRule: '新建告警规则',
    ruleName: '规则名称',
    ruleNamePlaceholder: '例如：CVR 过低告警',
    metricLabel: '指标',
    conditionLabel: '条件',
    campaignFilter: 'Campaign（留空=全部）',
    recentCount: '最近 100 条',
    pastHours: '过去 {h}h',
    currentValue: '当前值',
    fired: '触发了 {n} 条告警',
    noFired: '检查完成，无告警触发',
    notifyEmail: '通知邮箱',
  },
  billing: {
    title: '用量与计费',
    currentPeriod: '本月用量',
    free: '免费',
    billableUsage: '计费用量',
    estimatedBill: '预估费用',
    pricingNote: '定价说明',
    free10k: '每月前 10,000 次点击免费',
    overage: '超出部分 $0.05 / 1,000 次',
    freeQuotaDesc: '每月前 {n} 次点击免费',
    overageDesc: '超出部分 ${price} / 1,000 次',
    customBadge: '定制套餐',
    allFeatures: '所有功能全部开放，无任何限制',
    invoiceHistory: '账单历史',
    invoiceMonth: '月份',
    invoiceClicks: '点击数',
    invoiceBilled: '计费点击',
    invoiceAmount: '金额',
    invoiceStatus: '状态',
    noInvoices: '暂无账单记录',
    enterprise: '月跑千万级点击？',
    enterpriseCta: '联系我们获取定制报价',
    usage: { clicks: '点击数' },
    status: { draft: '草稿', issued: '已出账', paid: '已付款' },
  },
  adminOrgs: {
    title: '机构管理',
    orgName: '机构名称',
    memberCount: '成员数',
    campaignCount: 'Campaign 数',
    monthClicks: '本月点击',
    customPlan: '定制套餐',
    createdAt: '注册时间',
    noData: '暂无机构',
    searchPlaceholder: '搜索机构名称或 ID...',
    detail: '详情',
    members: '成员列表',
    recentCampaigns: '近期 Campaign',
    totalCount: '共 {n} 个机构',
    estimatedBill: '预估费用',
  },
  adminBilling: {
    title: '定制套餐管理',
    addConfig: '新增定制套餐',
    editConfig: '编辑定制套餐',
    orgName: '组织名称',
    freeClicks: '免费额度（次/月）',
    pricePerK: '超出单价（/ 千次）',
    note: '备注',
    notePlaceholder: '例如：VIP 客户、企业协议',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    deleteConfirm: '确认删除该定制套餐？删除后该客户将恢复默认定价。',
    noConfigs: '暂无定制套餐',
    searchOrg: '搜索组织名称或 ID',
  },
  offer: {
    title: 'Offer 管理',
    create: '新建 Offer',
    payout: 'Payout',
    status: {
      active: '运行中',
      paused: '已暂停',
      archived: '已归档',
    },
    searchPlaceholder: '搜索名称或 URL...',
    noData: '暂无 Offer',
    editTitle: '编辑 Offer',
    createTitle: '新建 Offer',
    nameLabel: '名称 *',
    namePlaceholder: '夏季促销 Offer',
    landingPageLabel: '关联落地页',
    noLandingPage: '不关联',
    currencyLabel: '货币',
    statusLabel: '状态',
    notesLabel: '备注',
    notesPlaceholder: '可选备注...',
  },
  landingPage: {
    title: '落地页管理',
    create: '新建落地页',
    url: 'URL',
    notes: '备注',
    searchPlaceholder: '搜索名称或 URL...',
    noData: '暂无落地页',
    editTitle: '编辑落地页',
    createTitle: '新建落地页',
    nameLabel: '名称 *',
    namePlaceholder: '首页落地页',
    notesLabel: '备注',
    notesPlaceholder: '可选备注...',
  },
  trafficSource: {
    title: '流量源管理',
    create: '新建流量源',
    type: '类型',
    subtitle: '管理您的广告流量来源和追踪配置',
    searchPlaceholder: '搜索流量源...',
    noData: '暂无流量源数据',
    noDataHint: '点击右上角按钮创建您的第一个流量源',
    preset: '预设',
    noDesc: '暂无描述',
    detailBtn: '详情',
    clone: '克隆',
    typeLabel: {
      all: '全部', google: '搜索广告', meta: '社交广告', tiktok: 'TikTok',
      native: '原生广告', push: 'Push广告', custom: '自定义',
    },
    quickCreate: '快速创建流量源',
    quickCreateDesc: '创建一个自定义流量源，用于追踪特定广告平台',
    nameLabel: '流量源名称',
    namePlaceholder: '例如：我的广告平台',
    descLabel: '描述（可选）',
    descPlaceholder: '流量源描述...',
    errName: '请输入流量源名称',
    createFailed: '创建失败，请重试',
    creating: '创建中...',
    createCustom: '创建自定义流量源',
    paramsPreview: '追踪参数预览',
    noMatch: '未找到匹配的流量源',
    editTitle: '编辑流量源',
    createTitle: '创建流量源',
    descLabel2: '描述',
    descPlaceholder2: '输入描述信息（可选）',
    trackingParams: '追踪参数',
    addParam: '+ 添加参数',
    noParams: '暂无追踪参数，点击上方按钮添加',
    paramName: '参数名称',
    paramDesc: '描述（可选）',
    required: '必填参数',
    postbackConfig: 'Postback 配置',
    postbackSupported: '支持 Postback',
    requestMethod: '请求方法',
    clickIdParam: 'Click ID 参数名',
    payoutParam: 'Payout 参数名',
    saveChanges: '保存更改',
    postbackUrlTemplate: 'Postback URL 模板',
    notFound: '流量源不存在',
    postbackNotSupported: '该流量源不支持 Postback',
    statusParam: 'Status 参数名',
    detail: {
      campaignCount: '关联活动',
      todayRoi: '今日 ROI',
    },
  },
  notFound: {
    title: '页面未找到',
    desc: '您访问的页面不存在。',
    back: '返回首页',
  },
  login: {
    subtitle: '登录您的账户以继续',
    signIn: '登录',
  },
  home: {
    freeTrial: '免费试用',
    nav: { features: '功能', pricing: '定价', faq: '常见问题' },
    hero: {
      title: '追踪每一次点击，按量付费',
      desc: '追踪链接、Postback 转化、多维实时报表，买量必备功能一个不少。前 10,000 次点击永久免费，超出仅 $0.05 / 千次，无订阅无隐藏费用。',
      start: '免费开始使用',
      demo: '查看演示',
      noCreditCard: '无需信用卡 · 随时可取消',
    },
    stats: { responseTime: '平均响应时间', uptime: '系统可用性', platforms: '支持广告平台', costSaving: '/ 千次点击' },
    features: {
      title: '核心功能', subtitle: '买量人真正需要的，一个不少',
      speed: { title: '不丢一个点击', desc: '50ms 边缘响应，Cloudflare 全球节点覆盖，追踪链接永不超时' },
      reports: { title: '秒级数据可见', desc: '点击发生后即刻入库，ROI、CVR、EPC 一眼看清' },
      multiPlatform: { title: '10+ 平台开箱即用', desc: '支持 Google、Meta、TikTok 等主流平台，也支持自定义流量源' },
      cost: { title: '按量付费，无最低消费', desc: '前 10,000 次点击永久免费，超出仅 $0.05 / 千次，无订阅无隐藏费用' },
      security: { title: '数据安全可靠', desc: '企业级加密存储，99.9% 可用性，数据永远属于你' },
      easyUse: { title: '5 分钟跑通追踪', desc: '无需培训，当天上线，创建 Campaign 到生成追踪链接只需几步' },
    },
    pricing: {
      title: '按量付费，从免费开始',
      subtitle: '无订阅，无最低消费，用多少付多少',
      freeClicks: '10,000',
      freeDesc: '次点击 / 月，永久免费',
      overageLabel: '超出后',
      overagePrice: '$0.05',
      overageUnit: '/ 1,000 次点击',
      featuresTitle: '所有功能全部开放，无任何限制',
      f1: '无限 Campaign', f2: 'Postback 转化追踪', f3: '流量分发规则',
      f4: '多维实时报表', f5: '欺诈点击过滤', f6: 'API 访问',
      examplesTitle: '费用示例',
      ex1l: '10,000 次 / 月', ex1p: '免费',
      ex2l: '100,000 次 / 月', ex2p: '$4.50',
      ex3l: '500,000 次 / 月', ex3p: '$24.50',
      ex4l: '1,000,000 次 / 月', ex4p: '$49.50',
      cta: '免费开始使用',
      noCreditCard: '无需信用卡 · 随时可取消',
      enterpriseTitle: '月跑千万级点击？',
      enterpriseCta: '联系我们获取定制报价',
    },
    faq: {
      title: '常见问题',
      q1: 'LiteTrack 和 Voluum 有什么区别？', a1: 'Voluum 月费 $149 起，功能复杂，学习曲线陡。LiteTrack 按量付费，前 10,000 次点击永久免费，超出仅 $0.05 / 千次，无订阅无最低消费。覆盖 90% 买量人的日常需求——追踪链接、Postback、多维报表、流量分发，开箱即用。如果你不需要 DSP 对接和白标，LiteTrack 是更聪明的选择。',
      q2: '数据存储在哪里？', a2: '数据存储在 Cloudflare 全球边缘网络，确保低延迟和高可用性。所有数据都经过加密处理。',
      q3: '支持哪些广告平台？', a3: '目前支持 Google Ads、Meta Ads、TikTok Ads、Microsoft Ads、Taboola、Outbrain、MGID、PropellerAds、Zeropark 等主流平台，也支持自定义流量源。',
      q4: '如何计费？', a4: '按实际点击量计费，每月前 10,000 次永久免费，超出后 $0.05 / 千次。无订阅，无最低消费，无需信用卡。',
    },
    cta: { title: '今天就跑通你的第一条追踪链路', desc: '免费注册，5 分钟完成配置。无需信用卡，随时可取消。', btn: '免费开始使用' },
    footer: { tagline: '买量人的轻量追踪工具', privacy: '隐私政策', terms: '服务条款', contact: '联系我们' },
  },
  dashboard: {
    activeCampaigns: '活跃 Campaign',
    todayClicks: '今日点击',
    todayConversions: '今日转化',
    cvr: 'CVR',
    welcome: '欢迎回来，{name}',
    user: '用户',
    overview: '以下是您今日的 Campaign 概览。',
    recentCampaigns: '最近 Campaign',
    draft: '草稿',
    createCampaign: '创建 Campaign',
    createCampaignDesc: '设置新的追踪 Campaign',
    viewReportsDesc: '查看详细数据分析',
  },
  campaigns: {
    subtitle: '管理和监控您的所有 Campaign',
    filter: '筛选',
    searchPlaceholder: '搜索 Campaign...',
    filterTitle: '筛选条件',
    clearAll: '清除全部',
    noFolders: '暂无文件夹',
    noTags: '暂无标签',
    selected: '已选 {n} 项',
    batchStart: '批量启动',
    batchPause: '批量暂停',
    batchArchive: '批量归档',
    batchDelete: '批量删除',
    noData: '暂无 Campaign',
    noDataHint: '创建您的第一个 Campaign 开始追踪',
    todayClicks: '今日点击',
    todayConversions: '今日转化',
    todayRevenue: '今日收入',
    todayCost: '今日成本',
    createdAt: '创建时间',
    totalRecords: '共 {n} 条记录',
    perPage: '{n} 条/页',
  },
  clicks: {
    title: '追踪日志',
    searchPlaceholder: 'Click ID 或 IP...',
    allCampaigns: '全部 Campaign',
    zoneIdPlaceholder: 'Zone ID...',
    bannerIdPlaceholder: 'Banner ID...',
    carrierPlaceholder: '运营商...',
    regionPlaceholder: '地区...',
    perPage: '{n} 条/页',
    columns: '列设置',
    noData: '暂无点击记录',
    pagination: '共 {total} 条，第 {page} / {pages} 页',
    detail: {
      title: '点击详情',
      subParams: 'Sub 参数',
      referrer: 'Referrer',
      userAgent: 'User Agent',
      queryParams: '查询参数',
      extraParams: '额外参数',
    },
    col: {
      time: '时间', clickId: 'Click ID', campaign: 'Campaign', ip: 'IP',
      location: '国家/城市', device: '设备', os: '操作系统', browser: '浏览器',
      sub1: 'Sub1', unique: '独立', fraud: '欺诈',
      city: '城市', region: '地区', timezone: '时区', isp: 'ISP',
      brand: '品牌', osVersion: '系统版本', browserVer: '浏览器版本',
      carrier: '运营商', connection: '连接类型', userActivity: '用户活跃度',
      zoneId: 'Zone ID', bannerId: 'Banner ID', cost: '成本',
    },
  },
  apiTokens: {
    title: 'API Token 管理',
    tokenCreated: 'Token 已创建 — 请立即复制，此后不再显示：',
    dismiss: '关闭',
    namePlaceholder: 'Token 名称',
    noTokens: '暂无 API Token',
    created: '创建于 {time}',
    lastUsed: '最后使用 {time}',
    never: '从未使用',
    revoke: '撤销',
  },
  testing: {
    title: '追踪测试',
    configTitle: '测试配置',
    payoutLabel: 'Payout ($)',
    sub1Label: 'sub1',
    sub1Optional: '（可选）',
    running: '测试中...',
    runTest: '运行完整测试',
    resultTitle: '测试结果',
    allPass: '全部通过',
    hasFail: '存在失败',
    step: {
      sendClick: '发送测试点击',
      sendPostback: '发送测试 Postback',
      verifyClick: '验证点击已入库',
      verifyConversion: '验证转化已入库',
    },
    detail: {
      skipNoClickId: '跳过：上一步未获取到 clickId',
      foundClickId: '找到 clickId: {id}',
      notFoundClickId: '未找到 clickId: {id}（共返回 {n} 条）',
    },
  },
  distribution: {
    title: '流量分发规则',
    createRule: '新建规则',
    noRules: '暂无规则，点击直接跳转 Campaign 的 Offer URL',
    defaultRule: '默认兜底',
    conditions: '匹配条件（全部满足）',
    targets: '分发目标（按权重随机）',
    addCondition: '+ 添加条件',
    addTarget: '+ 添加目标',
    priority: '优先级（数字越小越优先）',
    isDefault: '设为默认兜底规则（无条件匹配）',
    weight: '权重',
    dailyClickCap: '每日点击上限',
    customUrl: '自定义 URL',
    noLimit: '不限',
    editRule: '编辑规则',
    newRule: '新建分发规则',
    ruleName: '规则名称',
    optional: '可选',
    directToOffer: '直接跳转 Offer',
    lpThenOffer: '先跳落地页，再由落地页跳转 Offer',
    noConditions: '无条件 = 匹配所有流量',
    paramName: '参数名',
    value: '值',
    targetUrl: '目标 URL',
    saving: '保存中...',
    ruleNum: '规则 #{n}',
    conditionLabel: '条件',
    targetLabel: '目标',
    weightLabel: '权重{n}',
    field: {
      country: '国家',
      device_type: '设备类型',
      os: '操作系统',
      browser: '浏览器',
      language: '语言',
      referrer: 'Referrer',
      param: 'URL 参数',
    },
    op: {
      eq: '等于',
      neq: '不等于',
      contains: '包含',
      in: '属于(逗号分隔)',
    },
  },
  postbackLog: {
    title: 'Postback 日志',
    noData: '暂无 Postback 记录',
    totalCount: '共 {n} 条',
    allCampaigns: '全部 Campaign',
    allStatus: '全部状态',
    success: '成功',
    failed: '失败',
    pagination: '共 {total} 条，第 {from}–{to} 条',
    col: {
      time: '时间',
      campaign: 'Campaign',
      clickId: 'Click ID',
      url: 'URL',
      method: '方法',
      httpStatus: 'HTTP',
      duration: '耗时',
      error: '错误',
    },
  },
}
